/*
 * guide.ts — local-guide card image lightbox (Event Details).
 *
 * Progressive: each card's photos are plain <a href="full.jpg"> thumbnails that
 * work with no JS (open the image directly). With JS + <dialog> support we
 * intercept the click and show the photo in a modal with prev/next.
 */

export function initGuideLightbox(): void {
  const groups = Array.from(document.querySelectorAll<HTMLElement>(".guide-card__media"));
  if (!groups.length || typeof HTMLDialogElement === "undefined") return;

  const dialog = document.createElement("dialog");
  dialog.className = "guide-lightbox";
  dialog.innerHTML =
    '<button type="button" class="guide-lightbox__close" aria-label="Close">&times;</button>' +
    '<button type="button" class="guide-lightbox__nav guide-lightbox__nav--prev" aria-label="Previous">&#8249;</button>' +
    '<img class="guide-lightbox__img" alt="" />' +
    '<button type="button" class="guide-lightbox__nav guide-lightbox__nav--next" aria-label="Next">&#8250;</button>';
  document.body.appendChild(dialog);

  const img = dialog.querySelector<HTMLImageElement>(".guide-lightbox__img")!;
  let urls: string[] = [];
  let idx = 0;

  const show = (i: number): void => {
    idx = (i + urls.length) % urls.length;
    img.src = urls[idx];
  };

  dialog.querySelector(".guide-lightbox__close")!.addEventListener("click", () => dialog.close());
  dialog.querySelector(".guide-lightbox__nav--prev")!.addEventListener("click", () => show(idx - 1));
  dialog.querySelector(".guide-lightbox__nav--next")!.addEventListener("click", () => show(idx + 1));
  dialog.addEventListener("click", (e) => {
    if (e.target === dialog) dialog.close();
  });
  document.addEventListener("keydown", (e) => {
    if (!dialog.open) return;
    if (e.key === "ArrowLeft") show(idx - 1);
    if (e.key === "ArrowRight") show(idx + 1);
  });

  groups.forEach((group) => {
    const links = Array.from(group.querySelectorAll<HTMLAnchorElement>("a[data-full]"));
    links.forEach((link, i) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        urls = links.map((l) => l.dataset.full || l.href);
        show(i);
        dialog.showModal();
      });
    });
  });
}
